import { Immutable } from "immer";
import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { FORM_HELP_TEXT_CLASS_NAME } from "../classNames";
import { getDescribedByElemID } from "../hooks/formUtils";

/**
 * Renders form field help text
 */
export const FormHelpText = (
    props: Immutable<{
        id?: string;
        helpText?: string;
        helpTextClass?: string;
    }>,
): React.ReactNode => {
    if (!props.helpText || !props.id) {
        return null;
    }

    const helpTextClasses = concatClassNames([
        FORM_HELP_TEXT_CLASS_NAME,
        props.helpTextClass,
    ]);

    return (
        <p
            className={helpTextClasses}
            id={getDescribedByElemID(props.id)}
            data-testid="form-help-text"
            dangerouslySetInnerHTML={{ __html: props.helpText }}
        />
    );
};
